(function () {
  'use strict';

  function initGallery(galleryEl) {
    var thumbsEl = galleryEl.querySelector('.mtrx-swiper-thumbs');
    var mainEl   = galleryEl.querySelector('.mtrx-swiper-main');
    var counterEl = galleryEl.querySelector('.mtrx-gallery__counter-cur');
    var total = mainEl ? mainEl.querySelectorAll('.swiper-slide').length : 0;

    if (!mainEl) return;

    var ar = parseFloat(galleryEl.style.getPropertyValue('--mtrx-ar')) || 1;

    // Set explicit height before Swiper init to prevent aspect-ratio feedback loop
    // with CSS Grid (which causes exponential size expansion via resize events)
    function setMainHeight() {
      var w = mainEl.offsetWidth;
      if (w > 0 && w < 5000) {
        mainEl.style.height = Math.round(w / ar) + 'px';
      }
    }

    setMainHeight();

    var thumbsSwiper = null;

    if (thumbsEl && total > 1) {
      thumbsSwiper = new Swiper(thumbsEl, {
        slidesPerView: 'auto',
        spaceBetween: 8,
        watchSlidesProgress: true,
        freeMode: false,
        direction: window.innerWidth >= 768 ? 'vertical' : 'horizontal',
        on: {
          resize: function (swiper) {
            var dir = window.innerWidth >= 768 ? 'vertical' : 'horizontal';
            if (swiper.params.direction !== dir) {
              swiper.changeDirection(dir, true);
            }
          }
        }
      });
    }

    var mainSwiper = new Swiper(mainEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      navigation: {
        nextEl: mainEl.querySelector('.swiper-button-next'),
        prevEl: mainEl.querySelector('.swiper-button-prev'),
      },
      zoom: { maxRatio: 3, minRatio: 1 },
      keyboard: { enabled: true, onlyInViewport: true },
      thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined,
      on: {
        slideChange: function (swiper) {
          if (counterEl) counterEl.textContent = swiper.activeIndex + 1;
        }
      }
    });

    function syncThumbsHeight() {
      if (!thumbsEl || window.innerWidth < 768) return;
      var h = mainEl.offsetHeight;
      if (h > 0 && h < 4000) {
        var numVisible = Math.min(5, total);
        var slideH = Math.floor((h - (numVisible - 1) * 8) / numVisible);
        galleryEl.style.setProperty('--mtrx-thumbs-h', h + 'px');
        galleryEl.style.setProperty('--mtrx-thumb-slide-h', slideH + 'px');
        thumbsSwiper && thumbsSwiper.update();
      }
    }

    function onResize() {
      setMainHeight();
      mainSwiper.updateSize();
      mainSwiper.updateSlides();
      syncThumbsHeight();
    }

    requestAnimationFrame(syncThumbsHeight);

    var firstImg = mainEl.querySelector('.swiper-slide:first-child img');
    if (firstImg) {
      if (firstImg.complete) {
        syncThumbsHeight();
      } else {
        firstImg.addEventListener('load', syncThumbsHeight, { once: true });
      }
    }
    window.addEventListener('resize', onResize);
  }

  function init() {
    // theme.js productImageGallery() checks slick-initialized on .productView-nav/.productView-for
    // at line 4661 before calling .slick(). Mark both so the entire block is skipped —
    // Slick is no longer in vendor.js; our custom Swiper handles the gallery via [data-mtrx-gallery].
    document.querySelectorAll('.productView-nav, .productView-for').forEach(function(el) {
      el.classList.add('slick-initialized');
    });
    document.querySelectorAll('[data-mtrx-gallery]').forEach(initGallery);
  }

  // Script has `defer` — DOM is fully parsed at execution time, layout is ready.
  // Calling init() directly (not on window.load) ensures heights are set before
  // first paint, preventing the visible thumbnail jump on page load.
  init();
})();
